<template>
  <div class="page-content" id="device-form">
    <Titlebar :incrustation="'fa-mobile-phone'" :backPath="'/devices/list'">
      <h1>{{ pageTitle }}</h1>
    </Titlebar>
    <div class="full-height">
      <div class="row justify-content-center full-height">
        <div class="col-6 col-xl-4">
          <UiCard>
            <form class="form full-height p-0">
              <div class="form-row row">
                <label class="col-4">{{ $t("device.name") }}</label>
                <input
                    type="text"
                    v-model="device.name"
                    name="name"
                    class="form-input col"
                    v-validate
                    data-vv-rules="required"
                    :data-vv-as="$t('device.name')"
                />
                <span
                    class="form-input-error"
                    v-show="showErrors['name'] && errors.has('name')"
                    @click="hideError('name')"
                >{{ errors.first("name") }}</span
                >
              </div>
              <div class="form-row row" v-can="'beepiz-select-groups'">
                <label class="h-auto align-items-start col-4">{{ $t("device.groupSelect") }}</label>
                <select
                    v-if="groups.length > 0 "
                    :disabled="!useDvFlagAccess('beepiz-group-can:update')"
                    v-model="device.groupId"
                    class="form-input col"
                >
                  <option value="">{{ $t("device.noGroup") }}</option>
                  <option v-for="group in groups" :value="group.id">
                    {{ group.name }}
                  </option>
                </select>
                <div class="form-label col" v-if="groups.length == 0">
                  {{ $t("device.noGroup") }}
                </div>
              </div>
              <div class="form-row row" v-if="hasAnalytic">
                <label class="col-4">{{
                    $t("device.registrations.analyticCode")
                  }}</label>
                <input
                    type="text"
                    v-model="device.analyticCode"
                    maxlength="30"
                    name="name"
                    class="form-input col"
                />
              </div>
              <div class="form-row row" v-if="hasPlanning">
                <label class="h-auto align-items-start col-4">{{ $t("device.planning") }}</label>
                <div class="form-label col multiline">
                  <div v-for="planning in plannings" class="link">
                    <router-link :to="'/parameters/planning/' + planning.id">
                      {{ planning.label }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="form-row row" v-if="hasPatrol">
                <label class="h-auto align-items-start col-4">{{ $t("device.patrol") }}</label>
                <div class="form-label col multiline">
                  <div v-for="patrol in patrols" class="link">
                    <router-link
                        :to="'/patrols/' + patrol.id"
                        title="Cliquer ici pour consulter la ronde"
                    >
                      {{ patrol.label }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="form-row row" v-if="isRmProvidable">
                <label class="h-auto align-items-start col-4">{{ $t("device.remoteMonitoring") }}</label>
                <div class="form-label col multiline">
                  <MonitoringStatus
                      :rmprocedures="device.rmprocedures"
                      :rmStatus="device.rmStatus"
                  />
                </div>
              </div>

              <div class="form-row row light">
                <label class="h-auto align-items-start col-4">{{ $t("device.license") }}</label>
                <div class="form-label col" v-html="renderLicenceNumber"></div>
              </div>

              <div class="form-row row light">
                <label class="h-auto align-items-start col-4">{{ $t("device.mobile") }}</label>
                <div
                    class="form-label col"
                    :class="{ multiline: device.slot2PhoneNumber }"
                >
                  <span v-if="device.slot1PhoneNumber">
                    <span>{{ device.slot1PhoneNumber }}</span>
                    <span v-if="device.slot1SimCarrier" class="text-xs">({{ device.slot1SimCarrier }})</span>
                  </span>
                  <span v-if="device.slot2PhoneNumber">
                    <br/><span class="text-mono">{{
                      device.slot2PhoneNumber
                    }}</span>
                    <span v-if="device.slot2SimCarrier" class="text-xs">({{ device.slot2SimCarrier }})</span>
                  </span>
                </div>
              </div>

              <div class="form-row row light">
                <label class="h-auto align-items-start col-4">{{ $t("device.model") }}</label>
                <div class="form-label col">
                  <strong>{{ device.deviceManufacturer | capitalize }}</strong>
                  {{ device.deviceModel | capitalize }}
                </div>
              </div>
              <div class="form-row row light">
                <label class="h-auto align-items-start col-4">{{ $t("device.os") }}</label>
                <div class="form-label col">{{ osString }}</div>
              </div>
              <div class="form-row row light">
                <label class="h-auto align-items-start col-4">{{ $t("device.appversion") }}</label>
                <div class="form-label col text-mono">{{ device.version }}</div>
              </div>

              <div v-for="(value, index) in device.accessories" :key="index" class="mb-3">
                <Accessory :accessoryType="index" :accessoryData="value"></Accessory>
              </div>

            </form>
          </UiCard>
        </div>
        <div class="col-6 col-xl-8" style="height: 100%">
          <div class="row bottom-border realtime-infos justify-content-center">
            <div
                class="col card watching d-flex mb-4"
                :class="{ active: realtimeInfos.watching.active }"
                style="background-color: transparent"
            >
              <div class="card-inner d-flex gap-3 p-3">
                <div class="left-item play-pause rounded-sm">
                  <i
                      class="fa"
                      :class="
                      realtimeInfos.watching.active ? 'fa-play' : 'fa-pause'
                    "
                  ></i>
                </div>
                <div class="infos flex-grow-1">
                  <div class="mb-1 font-medium">
                    <span v-if="realtimeInfos.watching.active">
                      {{ $t("device.realtime.watchingSince") }}
                      <strong>{{ watchingTime }}</strong>
                    </span>
                    <span v-else>
                      {{ $t("device.realtime.notWatching") }}
                    </span>
                  </div>
                  <div
                      v-if="
                      realtimeInfos.watching.offlineZoneDeadline &&
                      device.offer != 57
                    "
                      class="d-flex align-items-center gap-2 mb-2"
                  >
                    <DeviceRealtimeStatus :status="'info'">
                      <i class="beepiz-offline-zone-in"></i>
                    </DeviceRealtimeStatus>
                    <span
                        class="offline-infos text-info-700"
                        v-if="realtimeInfos.watching.offlineZoneDeadline"
                    >{{ $t("device.realtime.offlineZoneDeadline") }}
                      <strong>{{ watchingOfflineZoneDeadline }}</strong></span
                    >
                  </div>
                  <div
                      v-if="realtimeInfos.watching.active && device.offer != 57"
                      class="d-flex"
                      style="gap: 0.5rem"
                  >
                    <DeviceRealtimeStatus
                        :status="
                        realtimeInfos.watching.alerts.verticality
                          ? 'active'
                          : 'inactive'
                      "
                    >
                      <i class="beepiz-verticality"></i>
                    </DeviceRealtimeStatus>
                    <DeviceRealtimeStatus
                        :status="
                        realtimeInfos.watching.alerts.immo
                          ? 'active'
                          : 'inactive'
                      "
                    >
                      <i class="beepiz-immo"></i>
                    </DeviceRealtimeStatus>
                    <DeviceRealtimeStatus
                        :status="
                        realtimeInfos.watching.alerts.fall
                          ? 'active'
                          : 'inactive'
                      "
                    >
                      <i class="beepiz-fall"></i>
                    </DeviceRealtimeStatus>
                    <DeviceRealtimeStatus
                        v-if="
                        device &&
                        device.temporaryWatchmen &&
                        !!device.temporaryWatchmen.length
                      "
                        status="info"
                        :title="$t('temporary_watchman.profil_realtime_title')"
                    >
                      <i v-html="iconTempWatchman"></i>
                    </DeviceRealtimeStatus>

                    <DeviceRealtimeStatus v-for="(item,index) in device.accessories" status="info"
                                          :title="Utils().getAccessoryInformation(index).label" :key="index">
                      <div class="size-6 do-svg-full" :title="Utils().getAccessoryInformation(index).label"
                           v-html="Utils().getAccessoryInformation(index).logo">
                      </div>
                    </DeviceRealtimeStatus>
                  </div>
                </div>
                <div class="right-item battery-info" v-if="device.offer != 57">
                  <div v-if="realtimeInfos.watching.active" class="battery">
                    <div class="battery-inner">
                      <div :style="getBatteryHeightStyle"></div>
                      <span :style="getBatteryBottomStyle" class="text-mono"
                      >{{ this.realtimeInfos.watching.battery }}%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4" v-if="realtimeInfos.identification != null">
              <div class="card identification">
                <div class="left-item user">
                  <img
                      v-if="realtimeInfos.identification != null"
                      :src="identificationPic"
                  />
                </div>
                <div class="infos">
                  <span v-if="realtimeInfos.identification != null"
                  >{{
                      $t("device.realtime.identification.usedBy")
                    }}<br/><strong>{{
                        realtimeInfos.identification.name
                      }}</strong></span
                  >
                  <span v-if="realtimeInfos.identification == null">{{
                      $t("device.realtime.identification.noIdentification")
                    }}</span>
                </div>
              </div>
            </div>
          </div>
          <UiCard>
            <div class="filter-config">
              <div>
                <h2 class="tw-mb-4">
                  <i class="fa fa-cogs"></i> {{ $t("device.profile") }}
                </h2>
              </div>
              <div>
                <div
                    class="profile-select width-full"
                    v-can="'beepiz-select-profiles'"
                >
                  <span
                      @click="toggleProfileList"
                      v-can="'beepiz-edit-devices'"
                  >
                    <i class="fa fa-caret-down"></i>
                    <i
                        class="fa fa-eye fa-pull-right"
                        @click.stop="showProfile(profileDef)"
                        v-can="'beepiz-edit-profiles'"
                    ></i>
                    <template v-if="profileDef.profileId">
                      <i
                          class="fa fa-fw profile-icon"
                          :class="profileDef.meta.icon"
                      ></i>
                      {{ profileDef.meta.name }}
                    </template>
                    <template v-if="!profileDef.profileId">
                      <i
                          class="fa fa-fw profile-icon"
                          style="visibility: hidden"
                      ></i>
                      {{ $t("device.noProfile") }}
                    </template>
                  </span>
                  <div
                      class="profile-select-values"
                      :class="{ show: showProfileList }"
                      v-on-clickaway="closeProfileList"
                      v-can="'beepiz-edit-devices'"
                  >
                    <div class="profile-select-values-inner">
                      <div
                          v-if="profile.profileId != profileDef.profileId"
                          v-for="profile in profiles"
                          @click="handleChangeProfile(profile)"
                      >
                        <i
                            class="fa fa-eye"
                            @click.stop="showProfile(profile)"
                            v-can="'beepiz-edit-profiles'"
                        ></i
                        ><i
                          class="fa fa-fw profile-icon"
                          :class="profile.meta.icon"
                      ></i
                      >{{ profile.meta.name }}
                      </div>
                    </div>
                    <div
                        class="profile-select-new"
                        @click="handleNewProfile()"
                        v-can="'beepiz-add-profiles'"
                    >
                      <i class="fa fa-fw profile-icon fa-plus"></i
                      >{{ $t("device.newProfile") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="tw-px-12 tw-mt-12 tw-mb-8">
                <FilterField
                    @filter="onFilter"
                    class="width-full"
                ></FilterField>
              </div>
            </div>
            <div
                class="row"
                style="height: calc(100% - 165px); filter: grayscale(0.125)"
            >
              <div class="col scroll config-col">
                <div class="tw-pt-2 tw-px-2">
                  <Config
                      v-if="device.profile"
                      :config="profileDef.config"
                      :filterStr="filterStr"
                      v-can="'beepiz-read-profiles'"
                      :version="device.version"
                      :datiOffer="device.offer"
                      :readonly="true"
                      style="pointer-events: none"
                  />
                  <div v-if="!device.profile" class="no-profile">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span v-html="$t('device.noProfileMessage')"></span>
                  </div>
                </div>
              </div>
            </div>
          </UiCard>
        </div>
      </div>
    </div>
    <div
        class="flex gap-2 tw-py-4 bg-gray-50 mt-3 px-2"
        style="
        position: sticky;
        bottom: 0;
        z-index: 2;
        margin-left: -0.5rem;
        margin-right: -0.5rem;
      "
    >
      <Btn
          :class="'primary danger pull-left'"
          @click.native.stop="handleDeassoc"
          v-if="device.offer != 57"
          v-can="'beepiz-delete-devices'"
      >
        <span
        ><i class="fa fa-unlink"></i> {{ $t("device.btns.deassoc") }}</span
        >
      </Btn>
      <router-link :to="getReportRoute" tag="span">
        <Btn :class="'default pull-left'">
          <i class="fa fa-file"></i> {{ $t("device.btns.goToReport") }}
        </Btn>
      </router-link>
      <div class="flex-1"></div>
      <router-link to="/devices/list" tag="span">
        <Btn :class="'pull-right'"> {{ $t("global.cancel") }}</Btn>
      </router-link>
      <Btn
          :class="['primary pull-right']"
          @click.native.prevent="validForm"
          v-can="'beepiz-edit-devices'"
      >
        {{ $t("global.save") }}
      </Btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/services/API.js";
import moment from "moment";
import Globals from "@/services/globals.js";
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import UiCard from "@/components/ui/Card";
import FilterField from "@/components/ui/Filter";
import Battery from "@/components/icons/Battery";
import Config from "@/views/profiles/Config";
import {mixin as clickaway} from "vue-clickaway";
import Icons from "@/services/iconMapping.js";
import Utils from "@/services/utils.js";
import pickBy from "lodash/pickBy";
import picto_standard from "@/assets/img/picto/1_Standard_yellow.svg";
import picto_premium from "@/assets/img/picto/2_Premium_yellow.svg";
import picto_enterprise from "@/assets/img/picto/3_Enterprise_yellow.svg";
import DeviceRealtimeStatus from "@/components/devices/realtime/DeviceRealtimeStatus.vue";
import UiBadge from "@/components/ui/Badge.vue";
import MonitoringStatus from "@/components/devices/MonitoringStatus.vue";
import Accessory from "@/components/accessories/Accessory.vue";
import {useDvFlag, useDvFlagAccess} from "../../services/featureFlag";

var userPlaceholderG = require("@/assets/img/user-no-img.png");
var sha1 = require("sha1");

export default {
  name: "ProfilesForm",
  components: {
    Accessory,
    Battery,
    Titlebar,
    Toolbar,
    Btn,
    UiCard,
    FilterField,
    Config,
    DeviceRealtimeStatus,
    UiBadge,
    MonitoringStatus,
  },
  mixins: [clickaway],
  computed: {
    hasAnalytic: function () {
      return window.V.clientInfos.beepiz_analytic_code;
    },
    hasPlanning: function () {
      if (this.device && this.device !== undefined) {
        return (
            this.device.beepizPlannings ||
            (this.device.group && this.device.group.beepizPlannings) ||
            (this.device.profile && this.device.profile.beepizPlannings)
        );
      }
      return false;
    },
    plannings() {
      let plannings = [];
      if (this.device) {
        if (this.device.profile && this.device.profile.beepizPlannings) {
          this.device.profile.beepizPlannings.forEach((planning) => {
            plannings.push({
              id: planning.id,
              label: planning.label,
            });
          });
        }

        if (this.device.group && this.device.group.beepizPlannings) {
          this.device.group.beepizPlannings.forEach((planning) => {
            plannings.push({
              id: planning.id,
              label: planning.label,
            });
          });
        }

        if (this.device.beepizPlannings) {
          this.device.beepizPlannings.forEach((planning) => {
            plannings.push({
              id: planning.id,
              label: planning.label,
            });
          });
        }

        plannings = plannings.filter(
            (planning, index, self) =>
                index === self.findIndex((t) => t.id === planning.id)
        );
      }
      return plannings;
    },
    hasPatrol: function () {
      if (this.device && this.device !== undefined) {
        return (
            this.device.patrols ||
            (this.device.group && this.device.group.patrols) ||
            (this.device.profile && this.device.profile.patrols)
        );
      }
      return false;
    },
    patrols() {
      let patrols = [];
      if (this.device) {
        if (this.device.profile && this.device.profile.patrols) {
          this.device.profile.patrols.forEach((patrol) => {
            patrols.push({
              id: patrol.id,
              label: patrol.name,
            });
          });
        }

        if (this.device.group && this.device.group.patrols) {
          this.device.group.patrols.forEach((patrol) => {
            patrols.push({
              id: patrol.id,
              label: patrol.name,
            });
          });
        }

        if (this.device.patrols) {
          this.device.patrols.forEach((patrol) => {
            patrols.push({
              id: patrol.id,
              label: patrol.name,
            });
          });
        }

        patrols = patrols.filter(
            (patrol, index, self) =>
                index === self.findIndex((t) => t.id === patrol.id)
        );
      }
      return patrols;
    },
    pageTitle: function () {
      return this.device.name;
    },
    osString: function () {
      if (this.device.deviceOs != null && this.device.deviceOsModel != null) {
        return this.device.deviceOs + " " + this.device.deviceOsModel;
      }
      return "";
    },
    watchingTime: function () {
      var date = moment
          .tz(
              this.realtimeInfos.watching.activeFrom.date,
              this.realtimeInfos.watching.activeFrom.timezone
          )
          .local();
      var day = date.format(Utils.t("datetime.date"));
      var today = moment().format(Utils.t("datetime.date"));
      var showDay = "";
      if (day != today) {
        showDay = " (" + day + ")";
      }
      return date.format("HH:mm") + showDay;
    },
    watchingOfflineZoneDeadline() {
      return Utils.readableDuration(
          moment
              .tz(
                  this.realtimeInfos.watching.offlineZoneDeadline.date,
                  this.realtimeInfos.watching.offlineZoneDeadline.timezone
              )
              .local()
              .diff(moment(), "seconds")
      );
    },
    identificationPic: function () {
      if (this.realtimeInfos.identification) {
        return this.realtimeInfos.identification.picture
            ? this.realtimeInfos.identification.picture
            : this.userPlaceholder;
      } else {
        return this.userPlaceholder;
      }
    },
    alertTime: function () {
      var date = moment(this.realtimeInfos.lastAlert.date);
      return date.format("hh:mm");
    },
    userPlaceholder: function () {
      return userPlaceholderG;
    },
    icons: function () {
      return Icons.profile;
    },
    getBatteryHeightStyle: function () {
      if (this.realtimeInfos.watching.active) {
        return "height:" + this.realtimeInfos.watching.battery + "%";
      }
      return "";
    },
    getBatteryBottomStyle: function () {
      if (this.realtimeInfos.watching.active) {
        if (this.realtimeInfos.watching.battery > 35) {
          return "bottom:" + (this.realtimeInfos.watching.battery - 25) + "%";
        }
        return "bottom:10%";
      }
      return "";
    },
    getReportRoute: function () {
      var end = moment();
      var start = moment().subtract(8, "hours");
      var period =
          start.format("YYYY-MM-DD HH:mm") + "_" + end.format("YYYY-MM-DD HH:mm");

      return "/reports/activity/dati-" + this.device.id + "/" + period;
    },
    renderLicence: function () {
      var ts = "";
      if (this.isRmProvidable) {
        ts =
            '<i class="option-label fa fa-bullhorn" title="' +
            Utils.t("device.registrations.licenceOption") +
            " télésurveilleur" +
            '"></i>';
      }

      switch (this.device.offer) {
        case "45":
          return (
              '<span class="licence-type-45 mr-1">' +
              picto_standard +
              "</span>&nbsp;" +
              Utils.t("device.registrations.licence45") +
              " " + ts
          );
        case "43":
          return (
              '<span class="licence-type-43 mr-1">' +
              picto_premium +
              "</span>&nbsp;" +
              Utils.t("device.registrations.licence43") +
              " " + ts
          );
        case "35":
          return (
              '<span class="licence-type-35 mr-1">' +
              picto_premium +
              "</span>&nbsp;" +
              Utils.t("device.registrations.licence35") +
              " " + ts
          );
        case "58":
          return (
              '<span class="licence-type-58 mr-1">' +
              picto_enterprise +
              "</span>&nbsp;" +
              Utils.t("device.registrations.licence58") +
              " " + ts
          );
        case "57":
          return (
              '<span class="licence-type-57 mr-1"><i class="fa fa-upload"></i>' +
              "</span>&nbsp;" +
              Utils.t("device.registrations.licence57") +
              " " + ts
          );
      }
    },
    renderLicenceNumber: function () {
      if (this.device && this.device.id) {
        var ret =
            '<span class="licence-number">' +
            '<span class="licence-symbol">' +
            '<i class="fa fa-hashtag"></i>' +
            "</span>" +
            '<span class="licence-text text-mono">' +
            Utils.pad(this.device.id, "0", 8) +
            "</span>" +
            "</span>";
        return ret;
      }
    },
    isRmProvidable() {
      return this.device.rmStatus != null && this.device.rmStatus != 12;
    },
    iconTempWatchman() {
      return require("@/assets/img/iconTemporaryWatchman.svg");
    }
  },
  data: () => ({
    device: {},
    filterStr: "",
    showErrors: {},
    showSaveActions: false,
    showProfileList: false,
    firstTimeProfileList: true,
    configChanges: true,
    realtimeInfos: {
      watching: {
        active: false,
        activeFrom: "2017-05-30 08:30:00",
        alerts: {
          verticality: true,
          immo: true,
          fall: true,
        },
        offlineZoneDeadline: null,
        battery: 48,
      },
      identification: null,
      lastAlert: {
        type: "sos",
        date: "2017-05-30 11:43:00",
      },
    },
    profileDef: {
      profileId: null,
      meta: {
        name: "",
        description: "",
        default: 0,
        hash: "",
        icon: "",
      },
      datis: [],
      config: {},
    },
    selectedProfil: null,
    profileDefOrigin: {},
    profiles: [],
    groups: [],
    interval: null,
    lastActivity: null,
  }),
  methods: {
    useDvFlagAccess,
    useDvFlag,
    Utils() {
      return Utils
    },
    formatTime(time) {
      let date = moment(time);
      return date.format("DD/MM/YYYY à HH:mm");
    },
    selectIcon: function (icon) {
      this.icon = icon;
    },
    onSelectDevice: function (item) {
    },
    onUnselectDevice: function (item) {
    },
    showActionsOrValidForm: function () {
      if (this.configChanges) {
        this.toggleActions();
      } else {
        this.validForm();
      }
    },
    toggleActions: function () {
      this.showSaveActions = !this.showSaveActions;
    },
    toggleProfileList: function () {
      this.showProfileList = !this.showProfileList;
      if (this.showProfileList == false) {
        this.firstTimeProfileList = true;
      }
    },
    closeProfileList: function () {
      if (this.showProfileList && !this.firstTimeProfileList) {
        this.showProfileList = false;
        this.firstTimeProfileList = true;
      } else {
        this.firstTimeProfileList = false;
      }
    },
    handleChangeProfile: function (profile) {
      if (!this.device.profile) {
        this.device.profile = {};
      }
      this.device.profile.id = profile.profileId;
      this.device.profile.name = profile.meta.name;
      this.device.profile.icon = profile.meta.icon;
      this.device.profile.hash = profile.meta.hash;
      this.closeProfileList();
      this.loadProfile();
    },
    showProfile: function (profile) {
      window.V._router.push("/configurations/profiles/" + profile.profileId);
    },
    handleNewProfile: function () {
      window.V._router.push(
          "/configurations/profiles/new?dati=" +
          this.$route.params.id +
          "&profile=" +
          this.profileDef.profileId
      );
    },
    validForm: function () {
      this.hideAllErrors();
      this.$validator
          .validateAll()
          .then(() => {
            window.Vfc.$refs.loading.show();
            var groupId = null;
            if (this.device.groupId != "" && this.device.groupId != null) {
              groupId = this.device.groupId;
            }

            var objToEdit = {
              name: this.device.name,
              groupId: groupId,
              profileId: this.profileDef.profileId,
              analyticCode: this.device.analyticCode || "",
            };

            axios
                .put(
                    API.route(API.endpoints.datis.edit, {
                      id: this.$route.params.id,
                    }),
                    objToEdit
                )
                .then((response) => {
                  window.Vfc.$refs.messages.sendMessage(
                      "success",
                      Utils.t("global.dataSaved")
                  );
                  if (response.status == 202) {
                    window.Vfc.$refs.messages.sendMessage(
                        "error",
                        Utils.t("device.noNotificationError")
                    );
                  }
                  window.V._router.push("/devices/list");
                })
                .catch((error) => {
                  if (error.response != null) {
                    var errorBag = this.$validator.errorBag;
                    if (error.response.status == 422) {
                      FormUtils.handleErrors(errorBag, error.response.data.message);
                    }
                    FormUtils.showAllErrors(this);
                  } else {
                  }
                  window.Vfc.$refs.loading.hide();
                });
          })
          .catch(() => {
            this.showAllErrors();
          });
    },
    showAllErrors: function () {
      for (var showError in this.showErrors) {
        this.showErrors[showError] = true;
      }
    },
    hideAllErrors: function () {
      for (var showError in this.showErrors) {
        this.showErrors[showError] = false;
      }
    },
    hideError: function (key) {
      this.showErrors[key] = false;
    },
    getMin: function (values) {
      var temp = values.split(";");
      return temp[0];
    },
    getMax: function (values) {
      var temp = values.split(";");
      return temp[1];
    },
    getStep: function (values) {
      var temp = values.split(";");
      return temp[2];
    },
    oddOrEven: function (tags, even) {
      if (even == null) even = 0;
      var i = 0;
      var newArray = pickBy(tags, function (obj, key) {
        var cond = i % 2 === parseInt(even);
        i++;
        return cond;
      });
      return newArray;
    },
    byColumn: function (tags, totalColumns, columnNumber) {
      var i = 0;
      var newArray = pickBy(tags, function (obj, key) {
        var cond = i % totalColumns === columnNumber - 1;
        i++;
        return cond;
      });
      return newArray;
    },
    addEmail(newTag) {
      const tag = {
        email: newTag,
      };
      this.emailsOptions.push(tag);
      this.emails.push(tag);
    },
    addPhone(newTag) {
      const tag = {
        phonenumber: newTag,
      };
      this.phonesOptions.push(tag);
      this.phones.push(tag);
    },
    onFilter: function (value) {
      this.filterStr = Utils.sanitize(value);
    },
    handleDeassoc: function () {
      const rmProcedureWarning = !!this.device.rmprocedures
          ? Utils.t("device.deassoc.rmProcedureWarning", {
            procedureName: this.device.rmprocedures[0].name,
            licenceId: Utils.formatLicenceId(this.device.id),
          })
          : "";
      window.Vfc.$refs.confirm.height = 30;
      window.Vfc.$refs.confirm.width = 50;
      window.Vfc.$refs.confirm.show({
        doubleConfirm: true,
        doubleConfirmMessage: Utils.t("device.deassoc.doubleConfirm"),
        title: Utils.t("device.deassoc.title"),
        content: Utils.t("device.deassoc.message", {
          lastActivity: moment(this.lastActivity).format(
              Utils.t("datetime.dateComplete")
          ),
          rmProcedureWarning,
        }),
        yesButtonText: Utils.t("device.btns.deassoc"),
        noButtonText: Utils.t("global.cancel"),
        callbackYes: () => {
          axios
              .delete(
                  API.route(API.endpoints.datis.delete, {
                    id: this.$route.params.id,
                  })
              )
              .then((response) => {
                window.Vfc.$refs.messages.sendMessage(
                    "success",
                    Utils.t("device.deassoc.successMessage")
                );
                window.V._router.push("/devices/list");
              })
              .catch((error) => {
              });
        },
      });
    },
    loadData: function () {
      axios
          .get(API.route(API.endpoints.datis.show, {id: this.$route.params.id}))
          .then((response) => {
            this.device = response.data;
            if (this.device.profile != null) {
              this.loadProfile();
            } else {
              window.Vfc.$refs.loading.hide();
            }
            this.loadProfiles();
            this.loadGroups();
            if (this.device.groupId == null) {
              this.device.groupId = "";
            }
          })
          .catch((error) => {
            if (error.response != null) {
            } else {
            }
          });
    },
    loadProfile: function () {
      axios
          .get(
              API.route(API.endpoints.profiles.show, {
                profileId: this.device.profile.id,
              })
          )
          .then((response) => {
            this.profileDef.profileId = response.data.profileId;
            this.profileDef.meta = response.data.meta;
            this.profileDef.config = response.data.config;
            for (var key in this.profileDef.config) {
              var obj = this.profileDef.config[key];
              if (obj.created_at != null) {
                if (
                    moment().diff(moment(obj.created_at), "days") <
                    Globals.durationNewProfileItemInDays
                ) {
                  obj.new = true;
                }
              }
              var isAlert = obj.alert != null;
              if (isAlert) {
                obj.description = Utils.t("profile.alerts." + key);
              }
              if (obj.type == "array") {
                if (obj.value == null) {
                  obj.value = [];
                } else {
                  var vals = obj.value.split(",");
                  obj.value = [];
                  for (var valKey in vals) {
                    var objToPush = {};
                    objToPush[key] = vals[valKey];
                    this.profileDef.config[key].value.push(objToPush);
                  }
                }
              }
            }
            window.Vfc.$refs.loading.hide();
          });
    },
    labelStateProcedure(status) {
      return Utils.t("remoteMonitoring.status.status" + status);
    },
    loadProfiles: function () {
      axios
          .get(
              API.endpoints.profiles.index +
              API.constructQueryParams({perpage: 9999999999999})
          )
          .then((response) => {
            this.profiles = response.data.data;
          });
    },
    loadGroups: function () {
      axios
          .get(
              API.endpoints.groups.index +
              API.constructQueryParams({perpage: 9999999999999})
          )
          .then((response) => {
            this.groups = response.data.data;
          });
    },
    loadStatus: function () {
      axios
          .get(
              API.route(API.endpoints.datis.status, {id: this.$route.params.id})
          )
          .then((response) => {
            var status = response.data;
            this.realtimeInfos.watching.active = status.datiSessionId != null;
            this.realtimeInfos.watching.activeFrom = status.datiSessionStartAt;
            this.realtimeInfos.watching.alerts.verticality =
                status.inhibitionVerticality == "0" ? true : false;
            this.realtimeInfos.watching.alerts.immo =
                status.inhibitionImmobility == "0" ? true : false;
            this.realtimeInfos.watching.alerts.fall =
                status.inhibitionFall == "0" ? true : false;
            this.realtimeInfos.watching.battery = status.battery;
            if (status.offline_zone_deadline) {
              this.realtimeInfos.watching.offlineZoneDeadline =
                  status.offline_zone_deadline;
            }
            if (status.activityAt) {
              this.lastActivity = status.activityAt.date;
            }

            if (status.identification) {
              this.realtimeInfos.identification = status.identification;
            } else {
              this.realtimeInfos.identification = null;
            }
          });
    },
  },
  created() {
  },
  mounted() {
    if (!useDvFlagAccess("beepiz-licence-can:read")) {
      this.$router.push({name: "AccessDenied", params: {slug: "devices"}});
    }
    this.loadStatus();
    this.loadData();

    this.interval = setInterval(() => {
      this.loadStatus();
    }, 40000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped></style>
